import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field, Form } from 'redux-form';

import { Button, renderDropdownList } from '../../../helpers';

function AttachUserForm({ items, errorMessage, handleSubmit, onClose, onSubmit }) {
  return (
    <Form onSubmit={handleSubmit(values => onSubmit(values))}>
      <div className="row">
        <div className="col-12">
          <Field name="user_id" label="Select Member" component={renderDropdownList} data={items} />
        </div>
      </div>

      {errorMessage ? <div className="alert alert-danger">{errorMessage}</div> : null}

      <div className="btn-group">
        <Button color="secondary" onClick={() => onClose()}>
          Close
        </Button>
        <Button submit color="success">
          Attach
        </Button>
      </div>
    </Form>
  );
}

AttachUserForm.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired
    })
  ).isRequired,
  errorMessage: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

AttachUserForm.defaultProps = {
  errorMessage: null
};

function validate({ user_ids: userIds }) {
  const errors = {};

  if (!userIds) {
    errors.user_ids = 'Please, select at least one member';
  }

  return errors;
}

export default reduxForm({ form: 'attach-user', validate })(AttachUserForm);
